var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSerialnumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 727",
    stroke: "#fff",
    d: "M.627 3.066v5.65"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5941",
    stroke: "#a1ff00",
    d: "M3.424 3.066h2.813v5.65H3.424z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 728",
    stroke: "#fff",
    d: "M8.527 11.285v5.65"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5942",
    stroke: "#a1ff00",
    d: "M11.194 11.285h2.813v5.65h-2.813z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5943",
    stroke: "#a1ff00",
    d: "M8.444 3.066h2.813v5.65H8.444z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 729",
    stroke: "#fff",
    d: "M14.054 3.066v5.65"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 730",
    stroke: "#fff",
    d: "M16.561 11.285v5.65"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5944",
    stroke: "#a1ff00",
    d: "M16.561 3.066h2.813v5.65h-2.813z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5945",
    stroke: "#a1ff00",
    d: "M.627 11.285H3.44v5.65H.627z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 731",
    stroke: "#fff",
    d: "M5.898 11.285v5.65"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 732",
    stroke: "#fff",
    d: "M19.373 11.285v5.65"
  }))));
}
export default SvgSerialnumber;